<template>
    <div>
        <el-collapse v-model="currentItem" accordion>
            <el-collapse-item  v-for="(files, folderName, index) in list" :key="folderName" :title="folderName" :name="index">
                <div v-if="currentItem==index">
                <images
                        :imgs="getImgs(files, folderName)"
                        :modalclose="true"
                        :keyinput="true"
                        :mousescroll="true"
                        :showplaybutton="true"
                        :showfullbutton="true"
                        :showclosebutton="true"
                        :showcaption="true"
                        imagecountseparator="из"
                        :showimagecount="true"
                        :showthumbnails="true"></images>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<style>
    .el-collapse-item__content .gallery {
        flex-direction: row;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .el-collapse-item__content .gallery .wrapper {
        flex: none;
        padding: 0;
    }
    .el-collapse-item__content {
        overflow-y: auto;
        max-height: 600px;
    }
    .el-collapse-item__header {
        font-size: 18px;
        color: #205D91;
    }
    .el-collapse-item__header {
        height: auto;
        line-height: 25px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
</style>

<script type="text/ecmascript-6">
export default {
    data() {
        return {
            currentItem: 0
        }
    },
    methods: {
        getImgs: function(files, folderName) {
            var imgs = [];

            _.forEach(files, function(path) {
                imgs.push({
                    imageUrl: path,
                    thumbUrl: path.replace(/([a-z])\/([0-9])/,'$1/resized/$2'),
                    caption: folderName
                });
            })

            return imgs;
        }
    },
    props: ['list', 'carouselHeight', 'carouselAutoPlay', 'carouselInterval']
}
</script>




// WEBPACK FOOTER //
// portfolio.vue?546d7ffb